import { Box, Typography } from "@dealer-center/core-components";
import { Locale } from "@dealer-center/ddc-core-utils";
import { SPACE_BLOCK } from "../../../components/UserInfo";

/**
 * FR-003's page heading.
 *
 * Split out of `IdentityHeader` when the card frame landed, because the two sit on opposite sides of
 * the card's edge: the `h1` is page furniture on the app background, while the identity row is the
 * card's first row. One component spanning that boundary could not be placed.
 */
export const PageHeading = () => {
  return (
    <Box sx={{ marginBottom: SPACE_BLOCK }}>
      <Typography variant={"h1"}>
        {Locale.getText("MANAGE_YOUR_USER_INFORMATION") as string}
      </Typography>
    </Box>
  );
};
